module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-17-1a6dcd71feb3981be69e5e953e11ce8e.png";